<div class='container' style='margin-top:5%; margin-bottom:50%' >

  <h1>Create blog </h1>
  <form [formGroup] = "blogForm"  >
    <mat-form-field class="example-full-width">
      <mat-label>Blog Name</mat-label>
      <input matInput required formControlName="blog_name" >
    </mat-form-field>
    <mat-form-field class="example-full-width">
      <mat-label>Blog Url</mat-label>
      <input matInput required  formControlName="blog_url" >
    </mat-form-field>
    <button mat-raised-button type='submit' (click)="createBlog()" >Create Blog</button>
  </form>



</div>
